module.exports = __webpack_public_path__ + "static/img/icn_notice.5950dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_notice.png
// module id = Q15Y
// module chunks = 10